import sectionComponent from "./sectionComponent";
import openModal from './modal';

export default class videoBg extends sectionComponent {
    constructor(el){
        super(el);
        this.hotspotContainer = this.element.querySelector('.hotspots');
        this.state = 'paused';
        let hotspots = JSON.parse(this.element.dataset.hotspots);
        hotspots.forEach(marker => {
            let image = document.createElement('img');
            image.src = "/app/img/hotspot.png";
            image.alt = marker.title;
            image.classList.add('hotspot');
            let position = marker.position.split(",");
            image.style.left=position[0];
            image.style.top=position[1];
            image.hotspot = marker;
            this.hotspotContainer.appendChild(image);
        });
        this.element.addEventListener('click', this.onHotspotClick.bind(this));
    }
   isOnViewPort(visible){
       if (visible) {
           this.start();
       } else {
           this.stop();
       }
   }
   isWithinViewPort(visible){
       // Not concerned about how far on the view port we are for this component
   }
   stop(){
        if (this.state == 'playing') {
            this.state = 'paused'
            this.element.querySelector('video').pause();
        }
   }
   start() {

    if (this.state == 'paused') {
        this.state = 'playing'
            //TODO: Detect failed promise indicating playback rejected to display manual play button
            this.element.querySelector('video').play();
        }
   }
   onHotspotClick(e) {
       let target = e.target;
       if (e.target.hotspot) {
            let hotspot = e.target.hotspot;
            openModal(hotspot.url, hotspot.title, this.start.bind(this));
       }
   }
}